import { render, staticRenderFns } from "./kpi-n.vue?vue&type=template&id=0778c9a0&scoped=true"
import script from "./kpi-n.vue?vue&type=script&lang=ts"
export * from "./kpi-n.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0778c9a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0778c9a0')) {
      api.createRecord('0778c9a0', component.options)
    } else {
      api.reload('0778c9a0', component.options)
    }
    module.hot.accept("./kpi-n.vue?vue&type=template&id=0778c9a0&scoped=true", function () {
      api.rerender('0778c9a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/performance-assessment/kpi-c/kpi-n.vue"
export default component.exports